import React from "react";
import DownloadVersionDialog from "../dialogs/DownloadVersionDialog";
import VersionTableRow from "../dialogs/VersionTableRow";

function DownloadArchivoVersionDialog({ versions, open, onClose }) {
  const [currentDownload, setCurrentDownload] = React.useState(false);

  const cambioRadioDowload = (e) => {
    setCurrentDownload(e.target.value);
  };

  return (
    <DownloadVersionDialog
      downloadUrl={currentDownload}
      open={open}
      onClose={onClose}
      title="Descargar versión de archivo"
    >
      {versions.map((version, index) => (
        <VersionTableRow
          key={version.id}
          currentVersionUrl={currentDownload}
          onCurrentVersionUrlChange={cambioRadioDowload}
          isFirstVersion={index === 0}
          versionDate={version.fecha_creacion}
          versionId={version.id}
          versionNumber={index + 1}
          versionTitle={version.descripcion}
          versionUrl={version.nombre}
        />
      ))}
    </DownloadVersionDialog>
  );
}

export default DownloadArchivoVersionDialog;
